import React from 'react';
import { Icon, AppLocaleProvider, Input } from 'sd-ui-components';
import { observer, inject } from 'mobx-react';
import './EventSearch.less';

const { FormattedMessage, injectIntl } = AppLocaleProvider;

@inject('ConfigStore')
@inject('AuthStore')
@inject('EventsStore')
@observer
class EventSearch extends React.Component {
  state = {
    couldNotFindEvent: '',
    searchValue: ''
  };

  handleChange = event => {
    this.setState({ searchValue: event.target.value });
  };

  handleSearch = async () => {
    const { EventsStore } = this.props;

    if (!this.state.searchValue) {
      return;
    }

    const eventNumber = this.state.searchValue.toUpperCase().trim();

    this.setState({ couldNotFindEvent: '', searchValue: eventNumber });
    await EventsStore.loadEventDetails([eventNumber]);

    if (
      !EventsStore.loadingErrors.eventDetails &&
      EventsStore.eventDetails[eventNumber]
    ) {
      this.props.onNavigateToEvent(eventNumber);
    } else {
      this.setState({ couldNotFindEvent: eventNumber });
    }
  };

  render() {
    const { EventsStore } = this.props;

    return (
      <div className="event-search-container">
        <Input
          placeholder={this.props.intl.formatMessage({
            id: 'App.EventSearch.EnterEventId',
            defaultMessage: 'Enter event ID'
          })}
          onChange={this.handleChange}
          suffix={
            <React.Fragment>
              {EventsStore.loading.eventDetails && (
                <Icon icon="loading" className="searching-spinner" />
              )}
              {!EventsStore.loading.eventDetails && (
                <Icon
                  icon="magnifier"
                  onClick={this.handleSearch}
                  className="search-icon"
                />
              )}
            </React.Fragment>
          }
          disabled={EventsStore.loading.eventDetails}
          onPressEnter={this.handleSearch}
        />

        {this.state.couldNotFindEvent && (
          <div className="event-search-error">
            <FormattedMessage
              id="App.EventSearch.NoEventsFound"
              defaultMessage="No events matching event ID: {eventId}"
              values={{
                eventId: this.state.couldNotFindEvent
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

export default injectIntl(EventSearch);



// WEBPACK FOOTER //
// ./src/containers/AppLayout/EventSearch.jsx